var _defs, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheFiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15.9,
    width: 12,
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 12 15.9"
    },
    viewBox: "0 0 12 15.9",
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs863"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style856",
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#363636;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#363636",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path858",
    d: "m 3.8,12.95 5,-5.0000002 -5,-5",
    className: "st0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheFiche);
export default __webpack_public_path__ + "static/media/fleche_fiche.7f03b62f57230d8721c3dcfb51ea4539.svg";
export { ForwardRef as ReactComponent };